/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_KeepInputs */

const en_us2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep training`)
};

const pt_br2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar treinando`)
};

const es_419_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir entrenando`)
};

const pt_pt2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar a treinar`)
};

const fr_fr2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_de2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitertrainieren`)
};

const it_it2_workout_live_forgotten_keep = /** @type {(inputs: Workout_Live_Forgotten_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua ad allenarti`)
};

/**
* | output |
* | --- |
* | "Keep training" |
*
* @param {Workout_Live_Forgotten_KeepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_keep = /** @type {((inputs?: Workout_Live_Forgotten_KeepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_KeepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_keep(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_keep(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_keep(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_keep(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_keep(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_keep(inputs)
	return en_us2_workout_live_forgotten_keep(inputs)
});
export { workout_live_forgotten_keep as "workout-live.forgotten_keep" }